import { Dialog, DialogContent, DialogContentText, DialogTitle, Grid } from '@mui/material';
import React from 'react'
import colors from '../../../colors';
import { texts } from '../../../general/texts';
import { selectUtilityState } from '../../../../features/utilities/utilitySlice';
import { useSelector } from 'react-redux';

export const TransactionDetailsDialog = (props) => {

  const isOpen = props.isConfirmationDialogOpen
  const utilitySliceState = useSelector(selectUtilityState) 

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (isOpen) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [isOpen]);

  return (
    <Grid>
      <Dialog
        open={isOpen}
        onClose={props.handleClose} 
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        PaperProps={{
            style: {
              borderRadius:'20px',
              width: '600px'
            },
          }}
      >
        <DialogTitle id="scroll-dialog-title" sx={{textAlign:'center', background:colors.gradientOrange, color:colors.white, fontSize:'1rem', fontFamily:'GerberaBold'}} >
            <span>{texts["title-transaction-details"]}</span>
        </DialogTitle>
        <DialogContent sx={{fontSize:'1rem', color:colors.darkBlue, textAlign:'start', fontFamily:"GerberaLight", p:5, mt:5}}>
               <div style={{ display: 'flex', flexDirection:'column', rowGap:2 }}>
                    <div style={{ display: 'flex', flexDirection:'row', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>{texts["productName"]}:</span> {props.data.productName}
                    </div>
                    <div style={{ display: 'flex', flexDirection:'row', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>{texts["type"]}:</span> {props.data.type== 1 ? 'Debit' : 'Credit'}
                    </div>
                    <div style={{ display: 'flex', flexDirection:'row', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>{texts["date"]}:</span> {props.data.date}
                    </div>
                    <div style={{ display: 'flex', flexDirection:'row', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>{texts["serial"]}:</span> {props.data.serial}
                    </div>
                    <div style={{ display: 'flex', flexDirection:'row', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>{texts["channel"]}:</span> {props.data.channel}
                    </div>
                    <div style={{ display: 'flex', flexDirection:'row', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>{texts["transId"]}:</span> {props.data.transId}
                    </div>
               </div>
               <div style={{ display: 'flex', flexDirection:'column', rowGap:2 }}>
               {
                props.data.details.map((detail, index) => (
                    <div key={index}  style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontWeight: 'bold' }}>{detail.label}:</span> {detail.value}
                    </div>
                ))
              }
               </div>
        </DialogContent>
      </Dialog>
    </Grid>
  )
}
export default TransactionDetailsDialog